<template>
  <div class="select-history-applicant">
    <div class="history-applicant-body">
      <div v-if="!isNodata && activeLetter" class="fixed-nav">
        <div class="active-letter">{{ activeLetter }}</div>
        <div class="selected-num">已选中 <span>{{selectedArchivesIdList.length}}</span> 个申请人</div>
      </div>
      <div class="applicant-content base-scroller" ref="applicantContent">
        <div
          class="applicant-group"
          :class="[`applicant-group-${letter}`]"
          v-for="letter in letterList"
          :key="letter"
        >
          <div class="group-title">{{ letter }}</div>
          <div class="group-content " >
            <div
              class="applicant-item"
              v-for="item in applicantMap[letter]"
              :key="item.archives_id"
              @click="onSelectApplicant(item)"
            >
              <select-history-applicant-item
                :applicant-item="item"
                :is-selected="selectedArchivesIdList.includes(item.archives_id)"
              ></select-history-applicant-item>
            </div>
          </div>
        </div>
        <div class="nodata" v-if="isNodata">
          <img
            class="nodata-img"
            src="https://o.666visa.cn/static/ssqpeer/product/history-applicant/nodata-img.png"
            alt=""
          />
          您还没有历史申请人
        </div>
      </div>
      <div class="applicant-index-fixed">
        <div
          @click="gotoIndexItem(letter)"
          class="index-item"
          :class="{ active: activeLetter === letter }"
          v-for="letter in letterList"
          :key="letter"
        >
          {{ letter }}
        </div>
      </div>
    </div>

    <div class="bottom-box">
      <button class="btn cancel" @click="onCancel()">取消</button>
      <button class="btn next" @click="onSubmit()">确定</button>
    </div>
  </div>
</template>

<script>
// 我的页面，还有个历史申请人，跟这个代码基本类似，所以修改请同步调整
import Http from '@/libs/http';
import { APPLICANT_IDENTITY_MAP } from '@/maps/applicant-maps';
import SelectHistoryApplicantItem from './select-history-applicant-item.vue';

export default {
  components: {
    SelectHistoryApplicantItem,
  },
  props: {
    applicantList: Array,
    identityList: Array,
  },
  data() {
    return {
      APPLICANT_IDENTITY_MAP,
      applicantMap: {},
      selectedArchivesIdList: [],
      loaded: false,
      activeLetter: '',
    };
  },
  computed: {
    innerApplicantList: {
      get() {
        return this.applicantList;
      },
      set(value) {
        this.$emit('update:applicant-list', value);
      },
    },
    letterList() {
      if (!this.applicantMap) return [];
      return Object.keys(this.applicantMap).sort();
    },
    isNodata() {
      return Object.keys(this.applicantMap).length === 0;
    },
    allApplicantList() {
      return Object.keys(this.applicantMap).reduce((list, key) => list.concat(this.applicantMap[key]), []);
    },
  },
  created() {
    this.init();
    this.selectedArchivesIdList = this.innerApplicantList
      .filter(item => item.archives_id)
      .map(item => item.archives_id);
  },
  mounted() {
    this.initScroll();
  },
  methods: {
    init() {
      this.applicantMap = {};
      this.activeLetter = '';
      Http.post('/archives_brief_query', {
        condition: this.condition || undefined,
      })
        .then((data) => {
          delete data.result.unknown;
          this.applicantMap = data.result;
          this.loaded = true;
          this.$nextTick(() => {
            this.computedActiveLetter();
          });
        })
        .catch((e) => {
          if (e) console.log(e);
        });
    },
    // 获取显示的护照号，加*
    getShowPassportNumber(passport_number) {
      if (passport_number && passport_number.length > 3) {
        const middle = Math.floor(passport_number.length / 2);
        passport_number = `${passport_number.substring(
          0,
          middle - 1,
        )}***${passport_number.substring(middle + 2)}`;
      }
      return passport_number;
    },
    gotoIndexItem(letter) {
      const el = document.querySelector(`.applicant-group-${letter}`);
      if (!el) return;
      this.$refs.applicantContent.scrollTo({
        top: el.offsetTop,
        behavior: 'smooth',
      });
    },
    initScroll() {
      if (!this.$refs.applicantContent) return;
      this.$refs.applicantContent.addEventListener('scroll', () => {
        this.computedActiveLetter();
      });
    },
    computedActiveLetter() {
      if (!this.$refs.applicantContent) return;
      try {
        // 本质上就是从上往下找，然后找到最后一个锚点元素top小于0的，也就是当前激活的。
        let activeLetter = this.letterList[0];

        const scrollTop = this.$refs.applicantContent.scrollTop;
        for (let index = 0; index < this.letterList.length; index++) {
          const letter = this.letterList[index];
          const groupEl = this.$refs.applicantContent.querySelector(
            `.applicant-group-${letter}`,
          );
          if (groupEl.offsetTop - 5 < scrollTop) {
            activeLetter = letter;
          } else {
            break;
          }
        }

        this.activeLetter = activeLetter;
      } catch (error) {
        //
        console.log(error);
      }
    },
    
    onSelectApplicant(item) {
      const index = this.selectedArchivesIdList.findIndex(id => id === item.archives_id);
      if (index === -1) {
        this.selectedArchivesIdList.push(item.archives_id);
      } else {
        this.selectedArchivesIdList.splice(index, 1);
      }
    },
    onCancel() {
      this.$emit('back');
    },
    onSubmit() {
      if (!this.loaded) return;
      // 等待添加的申请人列表
      const addApplicantList = this.selectedArchivesIdList.filter(archives_id => 
        // 都不存在，则需要添加
        this.innerApplicantList.every(item => item.archives_id !== archives_id),
      ).map(id => this.allApplicantList.find(item => item.archives_id === id));

      // 先删除不要的
      let newList = this.innerApplicantList.filter((item) => {
        if (!item.archives_id) return true;
        // 包含才不删除
        return this.selectedArchivesIdList.includes(item.archives_id);
      });

      // 补充一个默认值
      if (newList.length === 0) {
        newList = [{}];
      }

      // 是否存在不支持的申请人身份
      let hasNonsupportIdentity = false;

      addApplicantList.forEach((item) => {
        // 支持的身份才赋值，否则指控
        const identityId = this.identityList.includes(item.identity_id) ? item.identity_id : undefined; 
        if (identityId === undefined && this.identityList[0] !== 5) {
          hasNonsupportIdentity = true;
        }
        // 如果找到了空的申请人，则不新增，直接替换
        const nullApplicantItem = this.innerApplicantList.find((item) => {
          // 可选择的身份只有一个，则会默认选中，所以这里判断一下
          const isDefaultIdentity = item.identity_id === undefined || this.identityList.length === 1;
          return !item.applicant_name && isDefaultIdentity && !item.file;
        });
        if (nullApplicantItem) {
          this.$set(nullApplicantItem, 'applicant_name', item.applicant_name);
          this.$set(nullApplicantItem, 'identity_id', identityId);
          this.$set(nullApplicantItem, 'archives_id', item.archives_id);
        } else {
          const applicantItem = {
            applicant_name: item.applicant_name,
            identity_id: identityId,
            archives_id: item.archives_id,
          };
          newList.push(applicantItem);
        }
      });

      if (hasNonsupportIdentity) this.$message.warning('存在不支持的申请人身份，请检查并重新选择申请人身份');

      this.innerApplicantList = newList;
      // 成功了返回上一页
      this.onCancel();
    
    },
  },
};
</script>

<style lang="less" scoped>
.select-history-applicant {
  padding: 24px 20px 32px 20px;
  background-color: white;
  position: relative;
  height: 566px;
  display: flex;
  flex-direction: column;
  .history-applicant-body {
    flex-grow: 1;
    overflow: hidden;
    position: relative;
    .fixed-nav{
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      background: #fff;
      height: 22px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      z-index: 1;
      .active-letter{
        font-size: 16px;
        line-height: 22px;
        font-weight: 600;
        color: #2f333d;
        padding: 0 8px;
      }
      .selected-num{
        color: #2F333D;
        font-size: 14px;
        span{
          color: #599FFF;
        }
      }
    }
    .applicant-content {
      max-height: 420px;
      overflow: auto;      
      .applicant-group {
        margin-bottom: 24px;
        &:last-child {
          margin-bottom: 0;
        }
        .group-title {
          padding-left: 8px;
          font-size: 16px;
          line-height: 22px;
          font-weight: 600;
          color: #2f333d;
        }
        .group-content {
          margin-top: 16px;
          display: flex;
          flex-wrap: wrap;
          margin-bottom: -16px;
        }
      }

      .nodata {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 48px;
        color: #91999f;
        font-size: 16px;
        .nodata-img {
          width: 280px;
          height: 180px;
          margin-bottom: 10px;
        }
      }
    }
    .applicant-index-fixed {
      position: absolute;
      right: 18px;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 16px;
      padding: 4px 0;
      border-radius: 1px;
      .index-item {
        font-size: 12px;
        line-height: 17px;
        color: #91999f;
        cursor: pointer;
        margin-bottom: 7px;
        &:last-child {
          margin-bottom: 0;
        }
        &:hover {
          color: #2f333d;
        }
        &.active {
          color: #2f333d;
          font-weight: 600;
        }
      }
    }
  }

  .bottom-box {
    flex-shrink: 0;
    margin-top: 40px;
    display: flex;
    align-items: center;
    gap: 40px;
    justify-content: center;
    .btn {
      width: 180px;
      height: 40px;
      background: #599fff;
      border-radius: 2px;
      border: 1px solid #599fff;
      font-size: 16px;
      color: #ffffff;
      cursor: pointer;
      outline: none;
      &:hover {
        opacity: 0.9;
      }
      &.cancel {
        color: #599FFF;
        background: #fff;
        border-color: #599FFF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/add-order/created-order/components/select-history-applicant.vue